// Object that enumerates all possible ways an in-product notification is orchestrated.
// We don't anticipate this enumeration to be updated frequently. If you want to introduce a new way to orchestrate IPNs, reach out to the Shared Services team.
export const IPN_IMPLEMENTATION = {
  BESPOKE: 'bespoke', // To be used if IPNs are orchestrated without using any vendor.
  ITERABLE: 'iterable', // To be used if IPN components are using the Iterable API.
  KNOCK_GUIDE: 'knock_guide', // To be used if IPN components are using the Knock Guides API.
  KNOCK_WORKFLOW: 'knock_workflow', // To be used if IPN components are using the Knock Feeds API.
  NOTIFICATION_STORE: 'notification_store', // To be used for Designer IPNs orchestrated by the NotificationStore.
  CALLOUT_POPOVER: 'callout_popover', // To be used for Designer IPNs orchestrated using Callout Popover.
} as const;

export type IpnImplementation =
  (typeof IPN_IMPLEMENTATION)[keyof typeof IPN_IMPLEMENTATION];
